


export const CREATE_ACTIVESHARABLELINKS = "CREATE_ACTIVESHARABLELINKS";   
export const RETRIEVE_ACTIVESHARABLELINKS = "RETRIEVE_ACTIVESHARABLELINKS";
export const RETRIEVEMENU_ACTIVESHARABLELINKS = "RETRIEVEMENU_ACTIVESHARABLELINKS";
export const RETRIEVESINGLE_ACTIVESHARABLELINKS = "RETRIEVESINGLE_ACTIVESHARABLELINKS";
export const UPDATE_ACTIVESHARABLELINKS = "UPDATE_ACTIVESHARABLELINKS";   
export const DELETE_ACTIVESHARABLELINKS = "DELETE_ACTIVESHARABLELINKS";  